import ReactDOM from "react-dom/client";
import App from "./App";
import "./assets/scss/index.scss";
import {BrowserRouter} from "react-router-dom";
import "./utils/i18n";
import * as Sentry from "@sentry/react";
import {$api} from "./api/api";
import SentryFallbackPage from "./Modules/Additionals/View/SentryFallbackPage";

Sentry.init({
    dsn: $api("sentry_dsn"),
    sendDefaultPii: true,
    integrations: [
        Sentry.replayIntegration(),
        Sentry.browserTracingIntegration(),
    ],
    tracesSampleRate: 1.0,
    tracePropagationTargets: ["localhost", process.env.REACT_APP_API_URL],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    environment: "staging",
    release: "bucard-frontend-v1.0.0",
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <Sentry.ErrorBoundary
        fallback={({error, resetErrorBoundary}) => (
            <SentryFallbackPage
                error={error}
                resetErrorBoundary={resetErrorBoundary}
            />
        )}
    >
        <BrowserRouter
            future={{v7_startTransition: true, v7_relativeSplatPath: true}}
        >
            <App/>
        </BrowserRouter>
    </Sentry.ErrorBoundary>
);
// Deploy test 20260125223636
